module.exports = __webpack_public_path__ + "static/media/tile-view.d4f4852c.svg";